import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, InputNumber, Switch, Button, Space, message } from 'antd';
import api from '../../../services/api';

const { Option } = Select;

const DEFAULT_VALUES = {
  charge_model: 1,
  payment_method: 1,
  charge_status: 'INACTIVE',
  charge_after_game: false,
  include_open_charges: true,
};

const ChargeSettingFormModal = ({ open, initialValues, onClose, onSaved }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const editingRecord = initialValues || null;

  useEffect(() => {
    if (!open) return;
    if (editingRecord) {
      form.setFieldsValue({ ...DEFAULT_VALUES, ...editingRecord });
    } else {
      form.resetFields();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, editingRecord]);

  const handleFinish = async (values) => {
    try {
      setLoading(true);
      if (editingRecord?.id) {
        const { charge_status, ...editableValues } = values;
        await api.put(`/organizer-charges/settings/${editingRecord.id}`, editableValues);
        message.success('Configuração atualizada com sucesso');
      } else {
        await api.post('/organizer-charges/settings', values);
        message.success('Configuração criada com sucesso');
      }
      form.resetFields();
      if (onSaved) onSaved();
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      message.error(backendMessage || 'Erro ao salvar configuração');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    if (onClose) onClose();
  };

  return (
    <Modal
      title={editingRecord ? 'Editar Configuração' : 'Nova Configuração de Cobrança'}
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={DEFAULT_VALUES}
      >
        <Form.Item
          name="charge_description"
          label="Descrição da Cobrança"
          rules={[{ required: true, message: 'Descrição é obrigatória' }]}
        >
          <Input placeholder="Ex: Mensalidade Janeiro 2024" />
        </Form.Item>

        <Form.Item
          name="charge_model"
          label="Tipo de Cobrança"
          rules={[{ required: true, message: 'Tipo é obrigatório' }]}
        >
          <Select disabled={!!editingRecord}>
            <Option value={1}>Recorrente</Option>
            <Option value={2}>Avulso</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="payment_method"
          label="Método de Pagamento"
          rules={[{ required: true, message: 'Método é obrigatório' }]}
        >
          <Select disabled={!!editingRecord}>
            <Option value={1}>PIX</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="charge_amount_recurring"
          label="Valor Mensalista (R$)"
          help="Deixe 0 se não cobrar mensalistas"
        >
          <InputNumber
            min={0}
            step={0.01}
            style={{ width: '100%' }}
            placeholder="0.00"
          />
        </Form.Item>

        <Form.Item
          name="charge_amount_one_time"
          label="Valor Avulso (R$)"
          help="Deixe 0 se não cobrar avulsos"
        >
          <InputNumber
            min={0}
            step={0.01}
            style={{ width: '100%' }}
            placeholder="0.00"
          />
        </Form.Item>

        <Form.Item
          name="charge_issue_day"
          label="Dia da Cobrança"
          help="Dia do mês para enviar cobrança recorrente (1-31)"
        >
          <InputNumber
            min={1}
            max={31}
            style={{ width: '100%' }}
            placeholder="5"
          />
        </Form.Item>

        <Form.Item
          style={{ paddingTop: '10px' }}
          name="charge_after_game"
          label="Cobrar Após Jogo"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        <Form.Item
          name="include_open_charges"
          label="Na geração de nova cobrança, incluir as cobranças que estão em aberto"
          valuePropName="checked"
        >
          <Switch defaultChecked />
        </Form.Item>

        {editingRecord && (
          <Form.Item
            name="charge_status"
            label="Status"
            rules={[{ required: true }]}
          >
            <Select disabled>
              <Option value="ACTIVE">Ativo</Option>
              <Option value="INACTIVE">Inativo</Option>
              <Option value="CANCELED">Cancelado</Option>
              <Option value="PROCESSED">Processado</Option>
            </Select>
          </Form.Item>
        )}

        <Form.Item style={{ paddingTop: '20px' }}>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              {editingRecord ? 'Atualizar' : 'Criar'}
            </Button>
            <Button onClick={handleCancel}>Cancelar</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChargeSettingFormModal;
